<template>
  <fullLayout>
    <div
      class="grid-page-wraper"
      :style="{ minWidth: minWidth, minHeight: minHeight }"
    >
      <div class="grid-page-content">
        <gridView
          v-if="config"
          :config="config"
        ></gridView>
      </div>
    </div>
  </fullLayout>
</template>
<script setup lang="ts">
import { computed, onMounted, onUnmounted, provide, ref } from 'vue';
import fullLayout from '../fullLayout/fullLayout.vue';
import gridView from './gridView.vue';
import mitt from 'mitt';
import type { GridConfig } from 'liyu-pc-base/typing';
import { getGridConfig } from './index';
import { gridPageStateSymbol, GridPageState } from './utils';
import { useRoute } from 'vue-router';
const route = useRoute();
const config = ref<GridConfig>(null);
const context = ref<any>({});
const eventBus = mitt();
const modelType = ref('');
const path_arr = route.path.split('/');
modelType.value = path_arr[path_arr.length - 1];

provide<GridPageState>(gridPageStateSymbol, {
  context: context,
  eventBus,
});
onMounted(async () => {
  config.value = (
    await getGridConfig(modelType.value, { context: context.value, eventBus })
  ).config;
  if (config.value.onMounted) {
    await config.value.onMounted(context.value, eventBus);
  }
});
onUnmounted(() => {
  if (config.value.onUnmounted) {
    config.value.onUnmounted(context.value, eventBus);
  }
});
const minWidth = computed(() => {
  if (config.value?.minWidth != null) {
    return config.value.minWidth;
  } else {
    return undefined;
  }
});
const minHeight = computed(() => {
  if (config.value?.minHeight != null) {
    return config.value.minHeight;
  } else {
    return undefined;
  }
});
</script>

<style lang="less">
.grid-page-wraper {
  height: 100%;
  width: 100%;
  padding: 5px;
}
.grid-page-content {
  height: 100%;
  width: 100%;
  border-radius: 4px;
}
</style>
